import { render, staticRenderFns } from "./BottomNavComponent.vue?vue&type=template&id=52bbc4f1&scoped=true&"
import script from "./BottomNavComponent.vue?vue&type=script&lang=js&"
export * from "./BottomNavComponent.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavComponent.vue?vue&type=style&index=0&id=52bbc4f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bbc4f1",
  null
  
)

export default component.exports